import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import Player from "source/app/domain/Player";
import { GetDefaultKeyValue } from "source/app/infrastructure/Data/KeyValues/defaultKeyValue";
import { TodaysValueWithHistory } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Helpers/TodaysValueWithHistory";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { ChangeCICOWeight } from "./ChangeCICOWeight";
import { GetWeightNumber } from "./GetWeightNumber";
import { CICOWeightAdvisories } from "./CICOWeightAdvisories";

export function CICOWeight() {
    const [keyValue, setKeyValue] = React.useState<IKeyValue>(
        GetDefaultKeyValue()
    );

    const [newValue, setNewValue] = React.useState<string>(`0`);

    ShareState(ESharedFunction.CICO_weight, keyValue, setKeyValue);

    const todaysWeightRecorded =
        keyValue.value === GetDefaultKeyValue().value
            ? 0
            : GetWeightNumber(keyValue.value);

    const todaysWeight = todaysWeightRecorded ?? 0;
    const delta = todaysWeight - Player.targetWeight;

    const deltaText =
        delta <= 0 ? `+${Math.abs(delta).toFixed(1)}` : `-${delta.toFixed(1)}`;

    return (
        <div
            style={{
                textAlign: "center",
                margin: "10px",
                borderRadius: "6px",
                background: "rgb(46 90 171 / 15%)",
                padding: "10px",
                flexGrow: 1,
            }}
        >
            <div>
                Weight:
                <span style={{ margin: `0px 5px` }}>
                    <TodaysValueWithHistory
                        {...{
                            todaysValue: todaysWeight,
                            keyValue,
                            sharedFunction: ESharedFunction.CICO_weight,
                        }}
                    />
                </span>
                lbs
            </div>
            <div
                style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                }}
            >
                <div>
                    <span>
                        Weight
                        <span
                            style={{
                                marginLeft: `10px`,
                                color:
                                    delta <= 0 ? `rgb(142 203 17)` : `inherit`,
                            }}
                        >
                            {deltaText}
                        </span>
                    </span>
                </div>
            </div>
            <ChangeCICOWeight
                {...{
                    newValue,
                    setNewValue,
                    sharedFunction: ESharedFunction.CICO_weight,
                }}
            />
        </div>
    );
}
